import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const ProffitSearchLandingPageStepSeparator = () => (_jsx("div", Object.assign({ className: 'proffit_search_landing_page_step_separator' }, { children: _jsx("div", Object.assign({ className: 'separator_inner' }, { children: _jsx("div", { className: 'separator_dots' }) })) })));
export default ProffitSearchLandingPageStepSeparator;
